/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdimonitorControl.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edimonitor-control";

export class AutogenModelEdimonitorControl<RowType extends ModelRow> extends Endpoint<RowType, RowEdimonitorControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdimonitorControl extends ModelRow<RowEdimonitorControlFields> {
	constructor(values?: Partial<RowEdimonitorControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdimonitorControlFields {
	archin_last_alive: string;
	archin_ping_int: number;
	archout_last_alive: string;
	archout_ping_int: number;
	autoin_last_alive: string;
	autoin_on_msg: string;
	autoin_ping_int: number;
	autoout_last_alive: string;
	autoout_ping_int: number;
	backup_profiles: string;
	bills_int: number;
	cbpmgr_last_alive: string;
	cbpmgr_ping_int: number;
	check_arrival_int: number;
	check_arrival_updt: string;
	check_dept_int: number;
	check_dept_update: string;
	chk_bills_created: string;
	chk_bills_trans: string;
	chk_cbp309_trans: string;
	chk_cbp350_proc: string;
	chk_cbp353_trans: string;
	chk_cbp355_proc: string;
	chk_cbp358_trans: string;
	chk_edi_processes: string;
	chk_funcack_in: string;
	chk_funcack_proc: string;
	chk_funcack_trans_out: string;
	chk_inbound_rec: string;
	chk_invoices_proc: string;
	chk_load_tenders: string;
	chk_outbound_rec: string;
	chk_remadv_proc: string;
	chk_replies_proc: string;
	chk_replies_trans: string;
	chk_reply_exp: string;
	chk_statuses: string;
	chk_statuses_proc: string;
	chk_statuses_trans: string;
	chk_tender_proc: string;
	chk_tenders_trans: string;
	commin_last_alive: string;
	commout_last_alive: string;
	commout_ping_int: number;
	company_id: string;
	day_of_month: number;
	day_of_week: number;
	id: number;
	inbound_rec_int: number;
	logout_last_alive: string;
	logout_ping_int: number;
	occurrence: string;
	outbound_rec_int: number;
	pre_statuses_int: number;
	pre_tenders_int: number;
	profile_backup_tod: number;
	rec_first_inbound: string;
	rec_first_outbound: string;
	rec_in_dir: string;
	rec_in_run_int: number;
	rec_in_runnable: string;
	rec_out_run_int: number;
	rec_out_runnable: string;
	refresh_api_user_dt: string;
	replies_int: number;
	reply_exp_int: number;
	run_rec_in_dir: string;
	statuses_int: number;
	tenders_int: number;
	time_of_day: number;
	zerobyte_delete: string;
	zerobyte_deleteage: number;
}

